import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '@api-client';
import { lastValueFrom } from 'rxjs';
import { UserStore } from '../../stores/user.store';

export const AuthGuard: CanActivateFn = async () => {
  const store = inject(UserStore);
  const userService = inject(UserService);
  const router = inject(Router);

  try {
    const user = await lastValueFrom(userService.userControllerGetMe());
    if (user) store.setUser(user);
    return true;
  } catch {
    await store.logout();
    return router.createUrlTree(['/sign-in']);
  }
};
